import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import FpgPlusIcon from '../../icons/fpgplusicon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DraggerIcon from '../../icons/draggericon';
import CatEditIcon from '../../icons/catediticon';
import FpgMinusIcon from '../../icons/fpgminusicon';
import TextField from '../../component/TextField'
import service from "../../services";
import SimpleReactValidator from 'simple-react-validator';
import Loader from '../../component/loader';
import commonImage from '../../commonImage';
//moment import
import moment from "moment";
//sweet alert
import swal from "sweetalert";
let sub;
export default class Accessibility extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            addVenuemodal: false,
            editVenuemodal: false,
            editaccessibility: false,
            acclist: [],
            accname: "",
            updateAccId: "",
            description: "",
            base64: "",
            imagePreloader: false,
            errorMsgShow: "",
            lastUpdatedBy: "",
            lastUpdatedAt: "",
            isEdited: false
        }
        this.apiserve = new service();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                accname: {  // name the rule
                    message: 'Location Accessibility Name is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                description: {  // name the rule
                    message: 'Location Accessibility Description is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    componentDidMount() {
        this.updatedAt()
        this.getAcceList()
        let self = this;

        sub = this.apiserve.getevent().subscribe((response) => {
            this.setState({
                loaderFlag: false
            })
            switch (response.event) {
                case "user|sff|getAllInitialForRedis":
                    var accLists = response ?.data ?.location ?.accessibility.map(function (el) {
                        let o = Object.assign({}, el);
                        return o;
                    });

                    this.setState({
                        acclist: accLists
                    })
                    break;
                case "location|accessibility|add":
                    if (!response.error) {
                        self.CloseModal();
                        self.getAcceList();
                    }
                    else {

                    }
                    break;
                case "location|accessibility|update":
                    if (!response.error) {
                        self.CloseModal();
                        self.getAcceList();
                    }
                    else {

                    }
                    break;
                case "location|accessibility|remove":
                    if (!response.error) {
                        self.CloseModal();
                        self.getAcceList();
                    }
                    else {

                    }
                    break;
                case "location|accessibility|changeOrder":
                    if (!response.error) {
                        self.getAcceList();
                    }
                    else {

                    }
                    break;
                case "location|getLastUpdated":
                    if (!response.error) {

                        this.setState({
                            lastUpdatedBy: response ?.data ?.updatedBy,
                            lastUpdatedAt: response ?.data ?.updatedAt,
                        })
                    }
                    break;
            }

        });


    }

    getAcceList = () => {
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});
    }
    updatedAt = () => {
        let data = {
            type: "2"
        }
        this.apiserve.sendevent("location|getLastUpdated", data);
    }

    AddVenue = () => {
        this.validator.hideMessages("");
        this.setState({
            addVenuemodal: true,
            accname: "",
            description: "",
            base64: "",
            errorMsgShow: "",
            isEdited: true
        })
    }

    CloseModal = () => {
        this.setState({
            addVenuemodal: false,
            editaccessibility: false,
            accname: "",
            description: "",
            base64: "",
            errorMsgShow: "",
            updateAccId: "",
            isEdited: false
        })
        this.validator.hideMessages("");
    }


    editAccessibility = (data) => {
        this.setState({
            addVenuemodal: true,
            editVenuemodal: true,
            accname: data.name,
            updateAccId: data._id,
            description: data.description,
            base64: data.image || "",
            errorMsgShow: "",
            editaccessibility: true,
            isEdited: false
        })
    }

    onDragEnd = (result) => {
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.acclist];
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                accessibilityId: _id,
                sortIndex: i + 1,
            });
        });

        const data = { order: updateArr };
        this.apiserve.sendevent("location|accessibility|changeOrder", data);


        this.setState({ isDraggable: true });
        this.setState({ acclist: arr });
    }

    deleteAccess = (data) => {
        // this.setState({
        //     loaderFlag:true
        // })


        swal({
            title: "Are you sure you want to delete this record?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                swal("Your record has been deleted!", {
                    icon: "success",
                });
                this.apiserve.sendevent("location|accessibility|remove", { accessibilityId: data._id });
            } else {
                swal("Your record is safe!");
            }
        });
    }

    addAccessibility = () => {
        this.setState({
            addVenuemodal: true,
            isEdited: true
        })
    }

    onInputChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        this.updateState({
            [name]: value
        })
    }

    updateState = (data, callback) => {
        this.setState({
            ...data,
            isEdited: true
        }, callback);
    }

    onChangeFile = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;
        if (Math.round(file.size / 1024) >= 2048) {
            this.setState({ errorMsgShow: 'Please upload a file smaller than 2 MB' });
            return;
        }
        const isImage = ['image/png', 'image/jpg', 'image/jpeg', 'image/svg+xml', 'image/svg'].includes(file.type) || file.name.includes('.svg');
        if (!isImage) {
            this.setState({ errorMsgShow: 'Please upload a file for PNG,JPG, JPEG or SVG' });
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({ imagePreloader: true, errorMsgShow: "" });
            commonImage(file, false, '', event.target.result).then((value) => {
                this.updateState({ base64: value, imagePreloader: false });
            });
        };
    }

    submitFn = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true })
            const { accname, description, updateAccId, base64 } = this.state;
            let data;

            if (updateAccId) {
                data = {
                    name: accname,
                    description: description,
                    image: base64,
                    accessibilityId: updateAccId
                }
                this.CloseModal();
            }
            else {
                data = {
                    name: accname,
                    description: description,
                    image: base64
                }
                this.CloseModal();

            }
            this.CloseModal();
            this.apiserve.sendevent(updateAccId ? "location|accessibility|update" : "location|accessibility|add", data);
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }


    render() {
        var updateAt = new Date(this.state.lastUpdatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')

        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>LOCATION</div>
                            <span onClick={this.addAccessibility}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <p></p>
                    <p className="update_date">
                        Last Update: {hour}:{minutes} {state} -  {moment(this.state.lastUpdatedAt).format('MM/DD/YY')}
                    </p>
                </div>
                <div className="cat_outer_content">
                    <div className="category_add_edit">
                        <div className="category_header relative">
                            <p>Location Accessibility </p>
                            <span className="add_icon d_flex" onClick={this.AddVenue}>
                                <FpgPlusIcon
                                    width="16"
                                    height="16"
                                    color="#ffffff"
                                    stroke="#4F4F4F"
                                />
                            </span>
                        </div>
                        <div className="list_wrap striped_droppable_table">
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <ul {...provided.droppableProps} ref={provided.innerRef}>
                                            {this.state.acclist.map((item, index) => (
                                                <Draggable
                                                    key={item._id}
                                                    draggableId={item._id}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <li
                                                            className="pointer d_flex d_flex_align_center"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <span className="cat_drag d_flex">
                                                                <DraggerIcon />
                                                            </span>
                                                            <p className="cat_name">{item.name}</p>
                                                            <div className="action d_flex d_flex_align_center">
                                                                <span
                                                                    className="cat_edit pointer"
                                                                    onClick={() => this.editAccessibility(item)}
                                                                >
                                                                    <CatEditIcon />
                                                                </span>
                                                                <span
                                                                    className="remove_cat pointer"
                                                                    onClick={() => this.deleteAccess(item)}
                                                                >
                                                                    <FpgMinusIcon
                                                                        width="16"
                                                                        height="16"
                                                                        color="#4F4F4F"
                                                                    />
                                                                </span>
                                                            </div>
                                                        </li>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </ul>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </div>


                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
                {/* popup */}
                <div className={`user_popup ${this.state.addVenuemodal ? "active" : ""}`} >
                    <span className="popup_overlay" onClick={this.CloseModal}></span>
                    <div className="cat_modal_inner">
                        <p className="cat_title text_center">
                            {this.state.editaccessibility ? 'Edit Location Accessibility' : 'Location Accessibility'}
                        </p>
                        <form onSubmit={(e) => this.submitFn(e)}>
                            <div className="field_row horizontal_field d_flex">
                                <label>Accessibility Icon</label>
                                <div className="cat_img_upload">
                                    <div className="cat_img radius_50 absolute_loader">
                                        {this.state.imagePreloader ? (
                                            <Loader />
                                        ) : (
                                            <img
                                                src={this.state.base64
                                                    ? this.apiserve.imageUrl + this.state.base64
                                                    : "/images/image-placeholder.png"}
                                                alt=""
                                            />
                                        )}
                                        <div className="input_file">
                                            <input
                                                type="file"
                                                ref={(ref) => (this.upload = ref)}
                                                style={{ display: "none" }}
                                                onChange={this.onChangeFile}
                                                accept=".png, .jpg, .jpeg, .svg"
                                            />
                                            <span className="add_icon" onClick={() => this.upload.click()}>
                                                <PlusIcon />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <span className="limit_text">2 MB Limit</span>
                            </div>
                            {this.state.errorMsgShow && <span style={{ color: "red" }}>{this.state.errorMsgShow}</span>}
                            <div className="field_row horizontal_field d_flex">
                                <TextField
                                    type="text"
                                    label="Location Accessibility Name"
                                    name="accname"
                                    id="accname"
                                    value={this.state.accname}
                                    onChange={this.onInputChange}
                                    fpgerror={this.validator.message("Venue Type Name", this.state.accname, "accname|required")}
                                />

                            </div>
                            <div className="field_row horizontal_field d_flex">
                                <label>Location Accessibility Description</label>
                                <div className="textarea_wrap">
                                    <textarea
                                        type="text"
                                        rows="12"
                                        name="description"
                                        value={this.state.description}
                                        onChange={this.onInputChange}
                                    ></textarea>
                                    <span style={{ color: "red" }}>
                                        {this.validator.message("Description", this.state.description, "description|required")}
                                    </span>
                                </div>
                            </div>
                            <div className="cat_btns text_center">
                                <button type="button" onClick={this.CloseModal}>
                                    CANCEL
                    </button>
                                <button
                                    className={this.state.editaccessibility && !this.state.isEdited ? "disabled" : "active"}
                                    disabled={this.state.editaccessibility && !this.state.isEdited}
                                    onClick={(e) => this.submitFn(e)}
                                >
                                    {this.state.updateAccId ? "UPDATE" : "SAVE"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}